module.exports = __webpack_public_path__ + "img/circlebg.75712640.svg";